/**
  * @class meleFiles
  * @description
  *
  * # Purpose
  * Implements `<mele-files>` custom web element.
  *
  * # Use
  * Create element in HTML:
  * ```
  * parentEl.innerHTML += '<mele-files></mele-files>';
  * ```
  * Create element in JavaScript:
  * ```
  * var el = elParent.appendChildren({
  *   tag: 'mele-files',
  *   icon: 'plain_plus',
  * })
  * ```
  *
  * # Implementation notes
  *
  */

import meleElement from 'meleElement'

const PROPERTIES = _.extend({}, {
  data: { type: 'string', description: 'raw data in base64 type' },
}, meleElement._properties)

const MIME_ICONS = {
  'application/pdf': 'file.pdf',
  'application/msword': 'file.doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'file.doc',
  'application/vnd.ms-excel': 'file.xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'file.xls',
  'application/vnd.ms-powerpoint': 'file.ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'file.ppt',
  'application/zip': 'file.zip',
  'application/octet-stream': 'file.generic',
}

export default class meleFiles extends meleElement {
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "icon"
  */
  dataChanged(value) {
    this.innerHTML = value
      .split('∫')
      .map(datauri => {
        if(/^data:image\//.test(datauri)) {
          return `<a class="img"><img src="${datauri}" /></a>`
        }else if(/^data:/.test(datauri)) {
          const m = /^data:([\w/\-.]+)/.exec(datauri)
          const icon = (m ? MIME_ICONS[m[1]] : null) || MIME_ICONS['application/octet-stream']
          return `<a href="${datauri}" download="attachment..."><mele-image icon="${icon}"></mele-image><mele-image icon="server.download"></mele-image></a>`
        }
        return ''
      })
      .join('')
    this.forAll('a.img', el=>{
      const me = this
      el.onclick = function() {
        const elModal = this.modalOpen({
          key: ':preview',
          class: 'canvas',
          outclick: ':modal.cancel',
        })
        const elImg = elModal._body.appendChildren({ tag: 'img' })
        elImg.onclick = ()=>elModal.modalClose()
        elImg.style = 'width: 90%; height: 90%; margin: auto; object-fit: contain;'
        elImg.src = this.find('img').src
      }
    })
  } // dataChanged
} // class meleFiles

meleFiles._properties = PROPERTIES
meleFiles.observedAttributes = _.keys(PROPERTIES)

window.customElements.define('mele-files', meleFiles)
